import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:5545642f-29b5-4386-8dd1-a7789c875f17",
    aws_user_pools_id: "eu-west-1_X8Ddpxqu4",
    aws_user_pools_web_client_id: "29g4jm6palt7flt5gfr20hn7u7",
    Auth: {
      identityPoolId: "eu-west-1:5545642f-29b5-4386-8dd1-a7789c875f17",
      region: "eu-west-1",
      userPoolId: "eu-west-1_X8Ddpxqu4",
      userPoolWebClientId: "29g4jm6palt7flt5gfr20hn7u7",
    },
    oauth: {
      domain: "whs-safer-prod-mena.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://prod.mena.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.mena.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
